import { store } from '../admin-store.js';
import { renderSidebar, bindSidebar, openSidebar } from './admin-sidebar.js';
import { renderHeader, bindHeaderExtras } from './admin-header.js';
import { eventBus } from '../events.js';
import { api } from '../admin-api.js';

let _currentPath = null;

export function renderLayout() {
    const app = document.getElementById('app');
    if (!app) return;

    if (!store.user) {
        // Not authenticated — render bare content container for login page
        app.innerHTML = '<div id="app-content" class="admin-login-wrapper"></div>';
        return;
    }

    const hash = window.location.hash.slice(1) || '/';
    const path = hash.split('?')[0];

    // Full re-render layout if first time or structural change
    if (!app.querySelector('.admin-layout')) {
        app.innerHTML = `
            <div class="admin-layout">
                ${renderSidebar()}
                <div class="admin-main">
                    ${renderHeader()}
                    <main class="admin-content" id="app-content"></main>
                </div>
            </div>`;
        bindSidebar();
        _bindLogout();
        bindHeaderExtras();
        _loadDashboardData();
    } else {
        // Update header and sidebar active state on navigation
        const headerEl = app.querySelector('.admin-header');
        if (headerEl) {
            headerEl.outerHTML = renderHeader();
            _bindLogout();
            bindHeaderExtras();
            // Re-bind hamburger to existing sidebar
            document.getElementById('hamburgerBtn')?.addEventListener('click', openSidebar);
        }
        _updateSidebarActive();
    }

    _currentPath = path;
}

function _updateSidebarActive() {
    const currentHash = window.location.hash || '#/';
    document.querySelectorAll('.sidebar-item').forEach(item => {
        const href = item.getAttribute('href');
        const isActive = currentHash === href ||
            (href !== '#/' && currentHash.startsWith(href));
        item.classList.toggle('active', isActive);
    });
}

function _bindLogout() {
    const headerLogout = document.getElementById('headerLogout');
    const sidebarLogout = document.getElementById('sidebarLogout');

    const doLogout = () => eventBus.emit('auth:logout');

    headerLogout?.addEventListener('click', doLogout);
    sidebarLogout?.addEventListener('click', doLogout);
}

export function getContentEl() {
    return document.getElementById('app-content');
}

async function _loadDashboardData() {
    try {
        const data = await api.get('/dashboard');
        store.dashboardData = data;
    } catch {
        // silently ignore
    }
}
